import { render, staticRenderFns } from "./InsFooter.vue?vue&type=template&id=859e465e&scoped=true&"
import script from "./InsFooter.vue?vue&type=script&lang=ts&"
export * from "./InsFooter.vue?vue&type=script&lang=ts&"
import style0 from "./InsFooter.vue?vue&type=style&index=0&id=859e465e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859e465e",
  null
  
)

export default component.exports